import React, { useEffect, useState, useRef } from "react";
import { ChevronUp, ChevronDown, Trash2, RefreshCw } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

const TerminalLog = () => {
  const [open, setOpen] = useState(false);
  const [logs, setLogs] = useState([]);
  const [autoRefresh, setAutoRefresh] = useState(true);
  const scrollRef = useRef(null);

  const fetchLogs = async () => {
    try {
      const { data } = await api.get("/logs?limit=80");
      setLogs(data.logs || []);
    } catch (e) {
      // ignore
    }
  };

  useEffect(() => {
    fetchLogs();
    if (!autoRefresh) return;
    const id = setInterval(fetchLogs, 3000);
    return () => clearInterval(id);
  }, [autoRefresh]);

  return (
    <div
      data-testid="terminal-log"
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-[var(--border)] terminal"
      style={{ height: open ? 320 : 40 }}
    >
      <div
        className="flex items-center justify-between px-4 h-10 cursor-pointer border-b border-zinc-800 bg-[#0A0A0B]"
        onClick={() => setOpen((o) => !o)}
        data-testid="terminal-toggle"
      >
        <div className="flex items-center gap-3">
          <span className="text-[10px] uppercase tracking-[0.2em] meta">API Console</span>
          <span className="text-xs text-zinc-400">{logs.length} events</span>
        </div>
        <div className="flex items-center gap-2">
          <Button
            data-testid="terminal-refresh"
            variant="ghost"
            size="sm"
            className="h-7 px-2 text-zinc-300 hover:text-white hover:bg-zinc-800"
            onClick={(e) => {
              e.stopPropagation();
              fetchLogs();
            }}
          >
            <RefreshCw className="w-3.5 h-3.5" />
          </Button>
          {open ? <ChevronDown className="w-4 h-4 text-zinc-400" /> : <ChevronUp className="w-4 h-4 text-zinc-400" />}
        </div>
      </div>

      {open && (
        <div ref={scrollRef} className="overflow-auto" style={{ height: 280 }}>
          {logs.length === 0 ? (
            <div className="p-4 meta">No API calls yet. Make a request from any page above.</div>
          ) : (
            <div className="divide-y divide-zinc-900">
              {logs.map((l, i) => (
                <div key={i} className="px-4 py-2 flex flex-col gap-1" data-testid={`log-row-${i}`}>
                  <div className="flex items-center gap-3 flex-wrap">
                    <span className={l.status === "ok" ? "ok" : "err"}>{l.status === "ok" ? "OK" : "ERR"}</span>
                    <span className="cmd">{l.command}</span>
                    <span className="meta">{l.duration_ms}ms</span>
                    <span className="meta">{l.sandbox ? "sandbox" : "production"}</span>
                    <span className="meta text-[10px]">
                      {new Date(l.timestamp * 1000).toLocaleTimeString()}
                    </span>
                  </div>
                  {l.error && <div className="err pl-4">{l.error}</div>}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TerminalLog;
